<app-hud></app-hud>
<div class="container">
    <div class="row" *ngIf="!person.team">
        {{person.name}}, choose a team
        <button class="btn btn-outline-dark" (click)="onTeamSelect(Team.BLUE)">Blue</button> or
        <button class="btn btn-outline-dark" (click)="onTeamSelect(Team.RED)">Red</button>
    </div>
    <div class="row">
        <div class="col-sm">
            <button class="btn btn-outline-dark" (click)="onStartGameClick()">Start Game!</button>
        </div>
    </div>
    <div class="row">
        <div class="col-sm">
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">Blue</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let p of game.people">
                        <tr *ngIf="p.team == Team.BLUE">
                            <td>
                                {{p.name}}
                                <fa-icon *ngIf="p.role == Role.SPYMASTER" [icon]="faBullhorn"></fa-icon>
                                <button *ngIf="p.id == person.id" class="btn btn-outline-dark" 
                                    (click)="onTeamSelect(Team.RED)">Switch to Red</button>
                                <button *ngIf="p.id == person.id && person.role == Role.SPY" class="btn btn-outline-dark" 
                                    (click)="onWordMasterSelect()">Be WordMaster</button>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <div class="col-sm">
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">Red</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let p of game.people">
                        <tr *ngIf="p.team == Team.RED">
                            <td>
                                {{p.name}}
                                <fa-icon *ngIf="p.role == Role.SPYMASTER" [icon]="faBullhorn"></fa-icon>
                                <button *ngIf="p.id == person.id" class="btn btn-outline-dark" 
                                    (click)="onTeamSelect(Team.BLUE)">Switch to Blue</button>
                                <button *ngIf="p.id == person.id && person.role == Role.SPY" class="btn btn-outline-dark" 
                                    (click)="onWordMasterSelect()">Be WordMaster</button>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
    <div class="row">
        <div class="col-sm">
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">Undecided</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let p of game.people">
                        <tr *ngIf="!p.team">
                            <td>
                                {{p.name}}
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>